module.exports = "https://qp-assets.quero.com/assets/images/landing/yellow-line.svg?b452a5b169f831365cf2ae31eae9d43e";